import React, { useEffect } from "react";
import { Avatar, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Horn from "./../../assets/icons/horn.svg";
import { closeNotification } from "../../store/slices/userSlice";

const NotificationsNav = ({ data }) => {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state?.user);

  useEffect(() => {
    const notificationTimeout = setTimeout(() => {
      dispatch(closeNotification({ isNew: false }));
    }, 10000); // 10 seconds in milliseconds

    return () => {
      clearTimeout(notificationTimeout);
    };
  }, [dispatch]);

  const handleClick = () => {
    dispatch(closeNotification({ isNew: false }));
  };

  return (
    <>
      <div className="flex justify-center mr-2 ml-2 2xl:w-90%">
        <Card className="w-full h-6 bg-red">
          <div className="flex items-center">
            <Avatar src={Horn} className="rounded-none h-2 w-2 ml-4" />
            <p className="text-white ml-2 font-medium" onClick={handleClick}>
              {data?.notification?.title} {data?.notification?.body}
            </p>
          </div>
        </Card>
      </div>
    </>
  );
};

export default NotificationsNav;
